import React, { Component, Fragment } from 'react';

import { Grid } from 'components/grid';
import { Loader } from 'components/loader';
import { Tabs } from 'components/tabs';
import { translate } from 'components/translate';
import { PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import get from 'lodash/get';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import { hideFixedActionsBar } from 'modules/content/helper';
import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import { Campaigns } from './campaigns';
import { TABS } from './constants';
import SalesGroup from './salesGroup/SalesGroup';
import SalesInfo from './salesInfo/SalesInfo';
import SalesService from './SalesService';
import SalesSubscriptionDetails from './salesSubscription/SalesSubscriptionDetails';

import './SalesManager.scss';

@translate()
@inject('MembershipStore')
export default class SalesManager extends Component {
  static propTypes = {
    MembershipStore: MobxPropTypes.objectOrObservableObject,
    t: PropTypes.func
  };

  constructor(props) {
    super(props);

    const showCampaign = FeatureToggleService.isEnabled(
      FeatureToggles.SalesCampaignList
    );
    const defaultTab = showCampaign ? TABS.CAMPAIGNS : TABS.SALES_INFO;
    const currentTab = get(props, 'location.state.tabIndex', defaultTab);

    this.state = {
      loading: true,
      showAccessPlus: false,
      currentTab
    };

    this.tabToHide = !showCampaign && TABS.CAMPAIGNS;
  }

  async componentDidMount() {
    SalesService.sendDashboardOfferEvent();
    await SalesService.getOffers();
    this.disableLoader();

    const showAccessPlus = await SalesService.getShowAccessPlus();

    this.setState({ showAccessPlus });
  }

  onTabChange = (index) => {
    this.setState({ currentTab: index }, () => {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      UiService.smoothScroll('body', 500);
    });

    const id = this.visibleFixedBarId(index);

    hideFixedActionsBar(id);
  };

  visibleFixedBarId(tabId) {
    return `config__fixedBar-${tabId ? tabId : ''}`;
  }

  renderCampaigns = () => <Campaigns />;

  renderSalesInfo = () => {
    return <SalesInfo fixedBarId={this.visibleFixedBarId('1')} />;
  };

  renderSalesGroupTab = () => {
    return (
      <SalesGroup
        fixedBarId={this.visibleFixedBarId('2')}
        tabIndex={this.state.currentTab}
      />
    );
  };

  renderSalesSubscriptionTab = () => {
    return (
      <SalesSubscriptionDetails fixedBarId={this.visibleFixedBarId('3')} />
    );
  };

  enableLoader() {
    this.setState({ loading: true });
  }

  disableLoader() {
    this.setState({ loading: false });
  }

  get tabs() {
    const { showAccessPlus } = this.state;
    const { subscription } = this.props.MembershipStore;
    const { t } = this.props;
    const tabs = [
      { name: t('general.campaigns'), render: this.renderCampaigns },
      {
        name: t('sales_manager.info'),
        track: 'Sales information',
        render: this.renderSalesInfo
      }
    ];

    if (showAccessPlus) {
      tabs.push({
        name: t('sales_manager.access_plus'),
        track: 'Plus access',
        render: this.renderSalesGroupTab
      });
    }

    if (subscription) {
      tabs.push({
        name: t('sales_manager.subscription_details'),
        track: 'Subscription details',
        render: this.renderSalesSubscriptionTab
      });
    }

    return tabs;
  }

  render() {
    const { loading } = this.state;

    return (
      <div className="sales_manager__wrapper content__grid">
        {loading ? (
          <Loader />
        ) : (
          <ContentBasePage className="sales_manager__grid">
            <ContentBasePage.Header
              hideBackHandler
              title="sales_manager.title"
            />

            <Grid block noborder transparent nopadding>
              <Tabs
                track={PAGE_VIEW_EVENTS.SALES}
                className="sales_manager__tabs"
                hide={this.tabToHide}
                tabs={this.tabs}
                actived={this.state.currentTab}
                onTabChange={this.onTabChange}
              >
                {this.tabs.map((tab) => (
                  <Fragment key={tab.name}>{tab.render()}</Fragment>
                ))}
              </Tabs>
            </Grid>
          </ContentBasePage>
        )}
      </div>
    );
  }
}
